import { useActionConfirm } from './useActionConfirm';

export const TITLE_STOPPING_PRESOAK = 'Stopping Presoak';
export const TITLE_STARTING_PRESOAK = 'Starting Presoak';

/**
 * Action hook for the presoak flow. Manages confirmation dialog state and
 * dispatches initiatePresoak or stopPresoak based on current presoak state.
 * @param {{ isPresoaking: boolean, initiatePresoak: Function, stopPresoak: Function, showToast: Function }} deps
 * @returns {import('./useActionConfirm').ActionHook}
 */
export function usePresoakAction({ isPresoaking, initiatePresoak, stopPresoak, showToast }) {
  const getTitle = () => isPresoaking ? TITLE_STOPPING_PRESOAK : TITLE_STARTING_PRESOAK;
  const onConfirm = () => isPresoaking ? stopPresoak() : initiatePresoak();
  return useActionConfirm(getTitle, onConfirm, showToast);
}
